<template lang="pug">
.panel-inner-section
  .panel-header
    slot(name="header")
    slot(name="actions")
  slot(name="body")
</template>

<script>
export default {
  name: 'EditDealTabInnerSection',
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.panel-inner-section
  padding-top space-M
  margin-top space-M
  border-top 1px solid grey300

.panel-header
  display flex
  justify-content space-between
  margin-bottom space-M
  align-items flex-start
</style>
